import _toNumber from 'lodash-es/toNumber';
import _isFinite from 'lodash-es/isFinite';
import _isNumber from 'lodash-es/isNumber';

import { Component } from '@angular/core';

import { GenericField, IGenericField } from '../generic-field';
import { faPlus, faMinus, IconDefinition } from "@fortawesome/free-solid-svg-icons";

/**
 * Number-field
 * Generate a simple text field
 * @extends GenericField
 * @deprecated
 * //////////////////////////////////////////////////////////
 * //////////////////////////////////////////////////////////
 * //////////////////////////////////////////////////////////
 * ////////// !!!! [DEPRECATED] !!!!! ///////////////////////
 * //////////////////////////////////////////////////////////
 * //////////////////////////////////////////////////////////
 * //////////////////////////////////////////////////////////
 */
@Component({
    selector: 'number-field',
    templateUrl: './number-field.component.html',
    styleUrls: ['./number-field.component.scss']
})
export class NumberFieldComponent extends GenericField implements IGenericField {

    public iconPlus: IconDefinition = faPlus;
    public iconMinus: IconDefinition = faMinus;

    constructor() {
        super();
    }

    public ngOnInit() {
        if (this.isInArray) {
            const tempArray = this.group.value;
            if (tempArray[this.controlName] === "") {
                tempArray[this.controlName] = 0;
            }
            this.group.patchValue(tempArray);
        }
    }

    public onKeyup($event: Event): void {
        let ctrl: any;
        let value: number;

        if (this.isInArray) {
            ctrl = this.group;
            value = ctrl.value;
        } else {
            ctrl = this.group;
            value = ctrl.value[this.controlName];
        }

        const min = _toNumber(this.min);
        const max = _toNumber(this.max);

        if (min && _isNumber(value) && value < min) {
            if (this.isInArray) {
                const tempArray = ctrl.value;
                tempArray[this.controlName] = min;
                ctrl.patchValue(tempArray);
            } else {
                ctrl.patchValue(min);
            }
        }
        if (max && _isNumber(value) && value > max) {
            if (this.isInArray) {
                const tempArray = ctrl.value;
                tempArray[this.controlName] = max;
                ctrl.patchValue(tempArray);
            } else {
                ctrl.patchValue(max);
            }
        }

        this.keyUp.emit($event);
    }

    public onKeydown($event: any): void {
        switch ($event.which) {
            case (38)://UP
                $event.preventDefault();
                this.increase();
                break;

            case (40): //DOWN
                $event.preventDefault();
                this.decrease();
                break;
        }
    }


    public onFocus(event) {
        super.onFocus(event);
        this.field.nativeElement.select();
    }
    /*
    * Add 1 or this.step to field value,
    * except if the result is > this.max
    */
    public increase(): void {
        this.field.nativeElement.select();

        const step = this.step ? _toNumber(this.step) : 1;
        const max = _toNumber(this.max);

        let ctrl: any;

        if (this.isInArray) {
            ctrl = this.group;
        } else {
            ctrl = this.group.get(this.controlName);
        }

        let oldValue = parseFloat(this.isInArray ? ctrl.value[this.controlName] : _toNumber(ctrl.value));

        if (!_isFinite(oldValue)) {
            oldValue = 0;
        }

        if (max && oldValue >= max) {
            if (this.isInArray) {
                const tempArray = ctrl.value;
                ctrl.patchValue(tempArray);
            } else {
                ctrl.patchValue(oldValue);

            }
        } else {
            let newValue = oldValue + step;
            newValue = newValue > max ? max : newValue;
            if (this.isInArray) {
                const tempArray = ctrl.value;
                tempArray[this.controlName] = newValue;
                ctrl.patchValue(tempArray);
            } else {
                ctrl.patchValue(newValue);
            }
        }
        this.field.nativeElement.select();
    }
    /**
     * Subtract 1 or this.step to field value,
     * except if the result is < this.min
     */
    public decrease(): void {
        this.field.nativeElement.select();

        const step = this.step ? _toNumber(this.step) : 1;
        const min = _toNumber(this.min);

        let ctrl: any;

        if (this.isInArray) {
            ctrl = this.group;
        } else {
            ctrl = this.group.get(this.controlName);
        }

        let oldValue = parseFloat(this.isInArray ? ctrl.value[this.controlName] : _toNumber(ctrl.value));

        if (!_isFinite(oldValue)) {
            oldValue = 0;
        }

        if (min && oldValue <= min) {
            if (this.isInArray) {
                const tempArray = ctrl.value;
                ctrl.patchValue(tempArray);
            } else {
                ctrl.patchValue(oldValue);

            }
        } else {
            let newValue = oldValue - step;
            newValue = newValue < min ? min : newValue;

            if (this.isInArray) {
                const tempArray = ctrl.value;
                tempArray[this.controlName] = newValue;
                ctrl.patchValue(tempArray);
            } else {
                ctrl.patchValue(newValue);

            }

        }
        this.field.nativeElement.select();
    }


    /**
     * @returns {boolean}
     */
    public testMin(): boolean {
        // get field value



        let ctrl: any;
        let value: number;

        if (this.isInArray) {
            ctrl = this.group;
            value = ctrl.value;
        } else {
            ctrl = this.group;
            value = ctrl.value[this.controlName];
        }

        // get step value
        const step = this.step ? _toNumber(this.step) : 1;
        const min = _toNumber(this.min);

        //
        if (this.min) {

            return (value <= min);
        }
        return false;
    }

    /**
     *
     * @returns {boolean}
     */
    public testMax(): boolean {
        // get field value
        let ctrl: any;
        let value: number;

        if (this.isInArray) {
            ctrl = this.group;
            value = ctrl.value;
        } else {
            ctrl = this.group;
            value = ctrl.value[this.controlName];
        }

        const max = _toNumber(this.max);

        // get step value
        const step = this.step ? _toNumber(this.step) : 1;

        //
        if (this.max) {
            return (value >= max);
        }
        return false;
    }

}
